import {ILobItem} from '../../../models/lob.model';
import {
  LobActions,
  LobActionsType,
} from '../../action/lob/lob.actions';

export const lobsFeatureKey = 'lobs';

export interface LobState {
  lobs: ILobItem[];
}

export const initialLobState: LobState = {
  lobs: [],
};

export const lobLoadReducer = (
  state = initialLobState,
  action: LobActions = {} as LobActions,
): LobState => {
  if (action.type === LobActionsType.load) {
    return {
      ...state,
      lobs: action.payload.lobs,
    };
  }
  return state;
};
